{
	"baseUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/modules",
	"localModuleAssetBasePath": "assets/praxis-proethica/modules",
	"modules": {
		"module-1": {
			"thumbnail": "module-1.png"
		},
		"module-2": {
			"thumbnail": "module-2.png"
		},
		"module-3": {
			"thumbnail": "module-3.png"
		},
		"module-4": {
			"thumbnail": "module-4.png"
		},
		"module-5": {
			"thumbnail": "module-5.png"
		},
		"module-6": {
			"thumbnail": "module-6.png"
		},
		"module-7": {
			"thumbnail": "module-7.png"
		},
		"module-8": {
			"thumbnail": "module-8.png"
		}
	}
}
